import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import apiRequest from '../../api/request';
import { getPaginationUrl } from '../../utils/constants/GetPaginationURL';
import { get } from 'lodash';

const initialState = {
  loading: false,
  resData: {
    data: [],
    meta: {},
  },
  courses: [],
  cros: [],
  projects: [],
  crmLists: [],
  croList: [],
  croDatas: {
    data: {},
    meta: {},
  },
  leadDetails: {
    data: [],
    meta: {},
  },
  academicCalendar: [],
  rescheduledCalendars: [],
  subjectEnrollmentIds: [],
  leadDetails: {},
  studentProfile: {},
  sesssioncount: [],
  sessionLogCrm: [],
  sessionLogCro: [],
  terminationData: {},
  terminationReasons: [],
  feePerSession: [],
  studentAttendanceView: [],
  tutorAttendanceView: [],
  ledgerData: [],
  trainerData: {},
  trainerLists: {},
  inactiveReasons: [],
  evaluationTracker: {},
  activeCourses: [],
  croList: [],
  admissionRegisterData: {},
  countryCodeAndCountry: [],
  monthWiseDataloading: false,
  monthWiseSessionData: [],
  admissionRegisterDataPQA: {},
  crosunderproject: [],
  admissionRegisterDataFinance: {},
  allcrolist: [],
  excelSheetData: [],
  nonCartStudentData: {},
  unMappedStudent: [],
  subjects: [],
  studentListAndTutorList: { studentData: [], trainerDatas: [] },
  tpHistory: [],
  studentPerfomanceDasboard: {
    data: {
      cards: {},
      result: [],
    },
    meta: [],
    loading: false,
  },
  admRegStudentProfile: [],
  academicEdit: [],
  admissionRegisterDataGridExtraLoading: false,
  admissionRegisterNewTableDataLoading: false,
  admissionRegisterNewTableData: {},
  assessmentDetails: {
    tableData: [],
    meta: {},
  },
  assessmentDetailsTypes: [],
  transactionHistory: [],
  attendanceTypes: [],
};

export const getCoursesForAdmRgstr = createAsyncThunk('CRDSlice/getCoursesForAdmRgstr', async () => {
  const res = await apiRequest({
    method: 'get',
    url: 'pre-data/getCourses',
  });
  return res;
});

export const getProjectsForAdmRgstr = createAsyncThunk('CRDSlice/getProjectsForAdmRgstr', async () => {
  const res = await apiRequest({
    method: 'get',
    url: `cr-pre-data/getProjects`,
  });
  return res;
});

export const getAssignedCrosForAdmRgstr = createAsyncThunk('CRDSlice/getAssignedCrosForAdmRgstr', async () => {
  const res = await apiRequest({
    method: 'get',
    url: 'pre-data/getAssignedCROs',
  });
  return res;
});

export const getCRMLists = createAsyncThunk('CRDSlice/getCRMLists', async () => {
  const res = await apiRequest({
    method: 'get',
    url: `users/all-users-under/direct/null`,
  });
  return res;
});

export const getCROLists = createAsyncThunk('ogdDashboardSlice/getCROLists', async (crmId) => {
  const res = await apiRequest({
    method: 'get',
    url: `users/all-users-under/${crmId}`,
  });
  return res;
});

export const getCRMViewCRODatas = createAsyncThunk('ogdDashboardSlice/getCRMViewCRODatas', async (dispatchParams) => {
  const { fromDate, toDate, crmId, selectedCROS, paginationData } = dispatchParams;
  const paginationUrl = getPaginationUrl(paginationData);
  let crosFilter = 'filters=';
  if (selectedCROS?.length > 0) {
    crosFilter += selectedCROS.map((name) => `${name}`).join(encodeURIComponent('+'));
  }
  const res = await apiRequest({
    method: 'get',
    url: `/crm-assesment-report/counts/${crmId}/${paginationUrl}&fromDate=${fromDate}&toDate=${toDate}${
      selectedCROS?.length > 0 ? `&${crosFilter}` : ''
    }`,
  });
  return res;
});

export const getCROViewLeadDetails = createAsyncThunk(
  'ogdDashboardSlice/getCROViewLeadDetails',
  async (dispatchParams) => {
    const { fromDate, toDate, croId, paginationData } = dispatchParams;
    const paginationUrl = getPaginationUrl(paginationData);
    const res = await apiRequest({
      method: 'get',
      url: `/crm-assesment-report/cro-details/${croId}${paginationUrl}&fromDate=${fromDate}&toDate=${toDate}`,
    });
    return res;
  },
);

export const getAcademicCalendar = createAsyncThunk('CRDSlice/getAcademicCalendar', async (data) => {
  const { subject_enrollment_id, tutorID } = data;
  const res = await apiRequest({
    method: 'get',
    url: `scheduled-calendar/?subject_enrollment_id=${subject_enrollment_id}&tutorID=${tutorID}${
      tutorID ? '&inHouse=true' : ''
    }`,
  });
  return res;
});

export const getRescheduledCalendars = createAsyncThunk('CRDSlice/getRescheduledCalendars', async (sessionId) => {
  const res = await apiRequest({
    method: 'get',
    url: `/scheduled-calendar/get-previous-schduled-data/${sessionId}`,
  });
  return res;
});

export const getSubjectEnrollmentIds = createAsyncThunk('CRDSlice/getSubjectEnrollmentIds', async (leadId) => {
  const res = await apiRequest({
    method: 'get',
    url: `crm-assesment-report/get-subject-datas?leadId=${leadId}`,
  });
  return res;
});

export const getLeadMinDetails = createAsyncThunk('ogdDashboardSlice/getLeadMinDetails', async (subEnrolmentId) => {
  const res = await apiRequest({
    method: 'get',
    url: `/scheduled-calendar/get-lead-details/${subEnrolmentId}`,
  });
  return res;
});

export const getStudentsProfileForCRD = createAsyncThunk('CRDSlice/getStudentsProfileForCRD', async (enrolmentnId) => {
  const res = await apiRequest({
    method: 'get',
    url: `/admission-register/get-student-profile/${enrolmentnId}`,
  });
  return res;
});

export const getDataForCrdAdmissionRegister = createAsyncThunk(
  'CRDSlice/getDataForCrdAdmissionRegister',
  async (dispatchParams) => {
    const { paginationData } = dispatchParams;
    const paginationUrl = getPaginationUrl(paginationData);
    const res = await apiRequest({
      method: 'get',
      url: `/admission-register${paginationUrl}&project=${dispatchParams.selectedProjectId.id}&status=${
        dispatchParams.selectedStatusId ? dispatchParams.selectedStatusId : 0
      }&course=${dispatchParams.selectedCourseId.id}&cro=${dispatchParams.selectedCroId.userID}&sortBy=${
        paginationData.sortModel.field
      }&sortDirection=${paginationData.sortModel.order}`,
    });
    return res;
  },
);

export const getDataForCrdAdmissionRegisterForNewCustomTable = createAsyncThunk(
  'CRDSlice/getDataForCrdAdmissionRegisterForNewCustomTable',
  async (dispatchParams, action) => {
    const params = new URLSearchParams({
      project: dispatchParams.selectedProjectId?.id || null,
      status: dispatchParams.selectedStatusId ?? null,
      course: dispatchParams.selectedCourseId?.id || null,
      cro: dispatchParams.selectedCroId?.userID || null,
      sortBy: dispatchParams.sortKey,
      sortDirection: dispatchParams.sortDir,
      page: dispatchParams.page,
      limit: dispatchParams.limit,
      search: dispatchParams.search,
      hardRefresh: dispatchParams.hardRefresh ? true : false,
    });
    const res = await apiRequest({
      method: 'get',
      url: `/admission-register?${params}`,
    });
    if (dispatchParams.limit == 'no') {
      return action.rejectWithValue(res);
    }
    return res;
  },
);

export const getCountryCodeAndCountry = createAsyncThunk('CRDSlice/getCountryCodeAndCountry', async () => {
  const res = await apiRequest({
    method: 'get',
    url: `/admission-register/get-country-list?page=1&limit=no`,
  });
  return res;
});

export const getTransactionHistory = createAsyncThunk(
  'CRDSlice/getTransactionHistory',
  async (course_enrollment_id) => {
    const res = await apiRequest({
      method: 'get',
      url: `/admission-register/get-income-history?course_enrollment_id=${course_enrollment_id}`,
    });
    return res;
  },
);

export const updateStudentDataFromAdmRegstr = createAsyncThunk(
  'deoSlice/updateStudentDataFromAdmRegstr',
  async (data) => {
    const res = await apiRequest({
      method: 'put',
      url: `admission-register/update-student?admn_no=${data?.admnNo}&course_enrollment_id=${data?.course_enrollment_id}`,
      data: data,
    });
    return res;
  },
);
export const updateCroNotes = createAsyncThunk('CRDSlice/updateCroNotes', async (data) => {
  const res = await apiRequest({
    method: 'put',
    url: `admission-register/update-cro-note/${data.course_enrollment_id}`,
    data: data,
  });
  return res;
});

export const getTotalsessions = createAsyncThunk('CRDSlice/getTotalsessions', async (course_enrollment_id) => {
  const res = await apiRequest({
    method: 'get',
    url: `admission-register/get-session-counts/${course_enrollment_id}`,
  });
  return res;
});

export const updateTotalSessions = createAsyncThunk('CRDSlice/updateTotalSessions', async (data) => {
  const res = await apiRequest({
    method: 'put',
    url: `admission-register/update-session-counts/${data.subject_enrollment_id}`,
    data: data,
  });
  return res;
});

export const getSessionLogCrm = createAsyncThunk('CRDSlice/getSessionLogCrm', async (course_enrollment_id) => {
  const res = await apiRequest({
    method: 'get',
    url: `admission-register/get-trainer-session-log/${course_enrollment_id}`,
  });
  return res;
});

export const getSessionLogCro = createAsyncThunk('CRDSlice/getSessionLogCro', async (course_enrollment_id) => {
  const res = await apiRequest({
    method: 'get',
    url: `admission-register/get-trainer-assignment-log/${course_enrollment_id}`,
  });
  return res;
});

export const updateCertificate = createAsyncThunk('CRDSlice/updateCertificate', async (data) => {
  const res = await apiRequest({
    method: 'put',
    url: `admission-register/update-certificate/${data.course_enrollment_id}`,
    data: data,
  });
  return res;
});

export const getTerminationData = createAsyncThunk('CRDSlice/getTerminationData', async (course_enrollment_id) => {
  const res = await apiRequest({
    method: 'get',
    url: `admission-register/get-termination-clearance-data/${course_enrollment_id}`,
  });
  return res;
});

export const getTerminationReasons = createAsyncThunk('CRDSlice/getTerminationReasons', async () => {
  const res = await apiRequest({
    method: 'get',
    url: `admission-register/get-course-inactive-reasons`,
  });
  return res;
});

export const updateTerminationData = createAsyncThunk('CRDSlice/updateTerminationData', async (data) => {
  const res = await apiRequest({
    method: 'put',
    url: `admission-register/update-termination-clearance-data/${data.course_enrollment_id}`,
    data: data,
  });
  return res;
});

export const getFeePerSession = createAsyncThunk('CRDSlice/getFeePerSession', async (course_enrollment_id) => {
  const res = await apiRequest({
    method: 'get',
    url: `admission-register/get-fee-per-session-datas/${course_enrollment_id}`,
  });
  return res;
});

export const getStudentAttendanceView = createAsyncThunk('CRDSlice/getStudentAttendanceView', async (data) => {
  const res = await apiRequest({
    method: 'get',
    url: `admission-register/get-students-attendance-data?year=${data.year}&month=${data.month}&course_enrollment_id=${data.course_enrollment_id}&page=${data.page}&limit=${data.limit}`,
  });
  return res;
});

export const getTutorAttendanceView = createAsyncThunk('CRDSlice/getTutorAttendanceView', async (data) => {
  const res = await apiRequest({
    method: 'get',
    url: `admission-register/get-trainer-attendance-data?year=${data.year}&month=${data.month}&trainer_id=${data.trainer_id}&cro_id=${data.cro_id}&page=${data.page}&limit=${data.limit}`,
  });
  return res;
});

export const getLedgerData = createAsyncThunk('CRDSlice/getLedgerData', async (data) => {
  const res = await apiRequest({
    method: 'get',
    url: `admission-register/get-current-ledger/${data.course_enrollment_id}?rownum=${data.rownum}`,
  });
  return res;
});

export const getTrainerData = createAsyncThunk('CRDSlice/getTrainerData', async (dispatchParams) => {
  const { paginationData, courseEnrollmentIdFromQuery } = dispatchParams;
  const paginationUrl = getPaginationUrl(paginationData);
  const res = await apiRequest({
    method: 'get',
    url: `admission-register/get-trainer-mapping-data/${courseEnrollmentIdFromQuery}/${paginationUrl}`,
  });
  return res;
});

export const getTrainerLists = createAsyncThunk('CRDSlice/getTrainerLists', async (dispatchParams) => {
  const { paginationData } = dispatchParams;
  const paginationUrl = getPaginationUrl(paginationData);
  const res = await apiRequest({
    method: 'get',
    url: `/admission-register/get-trainer-checklist${paginationUrl}`,
  });
  return res;
});

export const assignTutor = createAsyncThunk('CRDSlice/assignTutor', async (data) => {
  const res = await apiRequest({
    method: 'post',
    url: `/admission-register/assign-trainer/${data.subjectEnrollmentId}`,
    data: data,
  });
  return res;
});

export const getInactiveReasons = createAsyncThunk('CRDSlice/getInactiveReasons', async () => {
  const res = await apiRequest({
    method: 'get',
    url: `/admission-register/get-unmapped-reasons`,
  });
  return res;
});

export const changeTutorStatus = createAsyncThunk('CRDSlice/changeTutorStatus', async (data) => {
  const res = await apiRequest({
    method: 'put',
    url: `/admission-register/change-trainer-status/${data.subjectEnrollmentId}`,
    data: data,
  });
  return res;
});

export const editAttendancePerDay = createAsyncThunk('CRDSlice/editAttendancePerDay', async (data) => {
  const res = await apiRequest({
    method: 'put',
    url: `admission-register/update-attendance-per-day`,
    data: data,
  });
  return res;
});

export const getEvaluationTracker = createAsyncThunk('CRDSlice/getEvaluationTracker', async (admsNo) => {
  const res = await apiRequest({
    method: 'get',
    url: `/evaluation-tracker?admn_no=${admsNo}`,
  });
  return res;
});

export const postEvaluation = createAsyncThunk('CRDSlice/postEvaluation', async (data) => {
  const res = await apiRequest({
    method: 'post',
    url: `/evaluation-tracker`,
    data: data,
  });
  return res;
});
export const deleteEvaluationTrack = createAsyncThunk('CRDSlice/deleteEvaluationTrack', async (id) => {
  const res = await apiRequest({
    method: 'delete',
    url: `/evaluation-tracker/${id}`,
  });
  return res;
});

export const getAllActiveCourses = createAsyncThunk('CRDSlice/getAllActiveCourses', async () => {
  const res = await apiRequest({
    method: 'get',
    url: `general/courses/1?page=1&limit=no`,
  });
  //
  return res;
});
export const getAllCroLists = createAsyncThunk('CRDSlice/getAllCroLists', async () => {
  const res = await apiRequest({
    method: 'get',
    url: `/general/get-all-cro-list`,
  });
  //
  return res;
});

export const CloseLedger = createAsyncThunk('CRDSlice/CloseLedger', async (data) => {
  const res = await apiRequest({
    method: 'post',
    url: `admission-register/close-ledger`,
    data: data,
  });
  return res;
});

export const getSessionDetailsAgainstSubEnrolId = createAsyncThunk(
  'CRDSlice/getSessionDetailsAgainstSubEnrolId',
  async (seletctedSubEnrollmentId) => {
    const res = await apiRequest({
      method: 'get',
      url: `/admission-register/get-month-wise-sessions/${seletctedSubEnrollmentId}`,
    });
    return res;
  },
);

export const getCROlistUnderProject = createAsyncThunk('CRDSlice/getCROlistUnderProject', async (deptID) => {
  const res = await apiRequest({
    method: 'get',
    url: `admission-register/get-project-cro-list?departmentID=${deptID}`,
  });
  return res;
});

export const getAdmissionRegisterDataforPQA = createAsyncThunk(
  'CRDSlice/getAdmissionRegisterDataforPQA',
  async (dispatchParams) => {
    const { paginationData } = dispatchParams;
    const paginationUrl = getPaginationUrl(paginationData);
    const res = await apiRequest({
      method: 'get',
      url: `/admission-register/get-data-for-spqa${paginationUrl}&project=${
        dispatchParams.selectedProjectId.id
      }&status=${dispatchParams.selectedStatusId ? dispatchParams.selectedStatusId : 0}&course=${
        dispatchParams.selectedCourseId.id
      }&cro=${dispatchParams.selectedCroId.userID}&sortBy=${paginationData.sortModel.field}&sortDirection=${
        paginationData.sortModel.order
      }&departmentID=${dispatchParams.deptID}`,
    });
    return res;
  },
);

export const getAdmissionRegisterDataforPQANewCustomTable = createAsyncThunk(
  'CRDSlice/getAdmissionRegisterDataforPQANewCustomTable',
  async (dispatchParams, action) => {
    const params = new URLSearchParams({
      project: dispatchParams.selectedProjectId.id || null,
      status: dispatchParams.selectedStatusId ?? null,
      course: dispatchParams.selectedCourseId.id || null,
      cro: dispatchParams.selectedCroId.userID || null,
      sortBy: dispatchParams.sortKey,
      sortDirection: dispatchParams.sortDir,
      departmentID: dispatchParams.deptID || null,
      page: dispatchParams.page,
      limit: dispatchParams.limit,
      search: dispatchParams.search,
      hardRefresh: dispatchParams.hardRefresh ? true : false,
    });
    const res = await apiRequest({
      method: 'get',
      url: `/admission-register/get-data-for-spqa?${params.toString()}`,
    });
    if (dispatchParams.limit == 'no') {
      return action.rejectWithValue(res);
    }
    return res;
  },
);

export const getAdmissionRegisterDataForFinance = createAsyncThunk(
  'CRDSlice/getAdmissionRegisterDataForFinance',
  async (dispatchParams) => {
    const { paginationData } = dispatchParams;
    const paginationUrl = getPaginationUrl(paginationData);
    const res = await apiRequest({
      method: 'get',
      url: `admission-register/get-data-for-finance${paginationUrl}&project=${
        dispatchParams.selectedProjectId.id
      }&status=${dispatchParams.selectedStatusId ? dispatchParams.selectedStatusId : 0}&course=${
        dispatchParams.selectedCourseId.id
      }&cro=${dispatchParams.selectedCroId.userID}&sortBy=${paginationData.sortModel.field}&sortDirection=${
        paginationData.sortModel.order
      }&forecast_type=${dispatchParams.typeID}`,
    });
    return res;
  },
);

export const getAdmissionRegisterDataForFinanceNewCustomTable = createAsyncThunk(
  'CRDSlice/getAdmissionRegisterDataForFinanceNewCustomTable',
  async (dispatchParams, action) => {
    const params = new URLSearchParams({
      project: dispatchParams.selectedProjectId?.id || null,
      status: dispatchParams.selectedStatusId ?? null,
      course: dispatchParams.selectedCourseId?.id || null,
      cro: dispatchParams.selectedCroId?.userID || null,
      sortBy: dispatchParams.sortKey,
      sortDirection: dispatchParams.sortDir,
      page: dispatchParams.page,
      limit: dispatchParams.limit,
      search: dispatchParams.search,
      forecast_type: dispatchParams.typeID || null,
      hardRefresh: dispatchParams.hardRefresh ? true : false,
    });
    const res = await apiRequest({
      method: 'get',
      url: `admission-register/get-data-for-finance?${params.toString()}`,
    });
    if (dispatchParams.limit == 'no') {
      return action.rejectWithValue(res);
    }
    return res;
  },
);
export const getAllCroList = createAsyncThunk('CRDSlice/getAllCroList', async () => {
  const res = await apiRequest({
    method: 'get',
    url: `admission-register/get-all-cro-list`,
  });
  return res;
});

export const getDataforExcelSheet = createAsyncThunk('CRDSlice/getDataforExcelSheet', async (dispatchParams) => {
  const res = await apiRequest({
    method: 'get',
    url: `admission-register/get-data-for-finance?page=1&limit=no&project=null&status=1&course=null&cro=null&sortBy=&sortDirection=&forecast_type=${dispatchParams.typeID}`,
  });
  return res;
});
export const updateForecast = createAsyncThunk('CRDSlice/updateForecast', async (data) => {
  const res = await apiRequest({
    method: 'post',
    url: `admission-register/change-forecast-method/${data.course_enrollment_id}`,
    data: data,
  });
  return res;
});

export const getNonCartStudentData = createAsyncThunk(
  'CRDSlice/getNonCartStudentData',
  async (course_enrollment_id) => {
    const res = await apiRequest({
      method: 'get',
      url: `cart/non-cart-edit-data/${course_enrollment_id}`,
    });
    return res;
  },
);

export const updateNonCartStudentData = createAsyncThunk('CRDSlice/updateNonCartStudentData', async (data) => {
  const res = await apiRequest({
    method: 'put',
    url: `cart/non-cart-edit-data/${data.course_enrollment_id}`,
    data: data,
  });
  return res;
});

export const getUnMappedStudentUnderCro = createAsyncThunk('CRDSlice/getUnMappedStudentUnderCro', async () => {
  const res = await apiRequest({
    method: 'get',
    url: `/match-making/get-unmapped-students`,
  });
  return res;
});

export const getSubjectsUnderEnrollmentId = createAsyncThunk(
  'CRDSlice/getSubjectsUnderEnrollmentId',
  async (courseEnrollmentId) => {
    const res = await apiRequest({
      method: 'get',
      url: `/match-making/get-subjects?course_enrollment_id=${courseEnrollmentId}`,
    });

    return res;
  },
);

export const getStudentListAndTutorList = createAsyncThunk('CRDSlice/getStudentListAndTutorList', async (data) => {
  const { subjectEnrollmentId, courseEnrollmentId, includeTimingPreference } = data;
  const res = await apiRequest({
    method: 'get',
    url: `/match-making/get-student-details?course_enrollment_id=${courseEnrollmentId}&subject_enrollment_id=${subjectEnrollmentId}&time_preference=${includeTimingPreference}`,
  });
  return res;
});

export const croTrainerStatusChange = createAsyncThunk('CRDSlice/croTrainerStatusChange', async (data) => {
  const res = await apiRequest({
    method: 'put',
    url: `/match-making/update-trainer-status`,
    data: data,
  });
  return res;
});

export const getTpHistory = createAsyncThunk('CRDSlice/getTpHistory', async (trainerId) => {
  const res = await apiRequest({
    method: 'get',
    url: `/match-making/get-tp-history?trainer_id=${trainerId}`,
  });
  return res;
});
// ------------------------Impact Report--------------------------------------
//                     ---- Student Perfomance Dashboard ----
export const getStudentPerfomanceDashboard = createAsyncThunk(
  'CRDSlice/getStudentPerfomanceDashboard',
  async (params) => {
    const filterParams = new URLSearchParams(params);
    const res = await apiRequest({
      method: 'get',
      url: `impact-report/get-student-performance-data?${filterParams}`,
    });

    return res;
  },
);

// AdmissionRegister studentEdit/profile Get
export const getAdmRegStudentDetails = createAsyncThunk('CRDSlice/getAdmRegStudentDetails', async (id) => {
  const res = await apiRequest({
    method: 'get',
    url: `students/student-details-edit/pre-data/${id}`,
  });
  return res;
});
// AdmissionRegister studentEdit/profile put
export const putAdmRegStudentDetails = createAsyncThunk('CRDSlice/putAdmRegStudentDetails', async ({ id, data }) => {
  const res = await apiRequest({
    method: 'put',
    url: `students/student-details-edit/edit/${id}`,
    data: data,
  });
  return res;
});

// ---------------------------------- AdmissionRegister studentEdit/profile -> get
export const getEditCalender = createAsyncThunk('CRDSlice/getEditCalender', async (id) => {
  const res = await apiRequest({
    method: 'get',
    url: `admission-register/get-calendar-days/${id}`,
  });
  return res;
});
// ---------------------------------- AdmissionRegister studentEdit/profile -> put
export const putEditCalender = createAsyncThunk('CRDSlice/putEditCalender', async (data) => {
  const res = await apiRequest({
    method: 'put',
    url: `admission-register/update-calendar-days`,
    data: data,
  });
  return res;
});

// ---------------------------------- Assessment Details
export const getAssessmentDetails = createAsyncThunk('CRDSlice/getAssessmentDetails', async (dispatchParams) => {
  const searchParams = new URLSearchParams(dispatchParams);
  const res = await apiRequest({
    method: 'get',
    url: `impact-report/get-student-examination-data?${searchParams.toString()}`,
  });
  return res;
});

// ---------------------------------- Assessment Details
export const getAssessmentDetailsType = createAsyncThunk(
  'CRDSlice/getAssessmentDetailsType',
  async ({ total_sessions, isHour }) => {
    const searchParams = new URLSearchParams({
      total_sessions,
      isHour,
    });
    const res = await apiRequest({
      method: 'get',
      url: `impact-report/get-student-examination-types?${searchParams.toString()}`,
    });
    return res;
  },
);
// -- put
export const putAssessmentDetails = createAsyncThunk('CRDSlice/putAssessmentDetails', async (data) => {
  const res = await apiRequest({
    method: 'put',
    url: `impact-report/update-student-examination-data`,
    data,
  });
  return res;
});
// -- post - duplicate
export const postDuplicateAssessmentDetails = createAsyncThunk(
  'CRDSlice/postDuplicateAssessmentDetails',
  async (data) => {
    const res = await apiRequest({
      method: 'post',
      url: `impact-report/duplicate-student-examination-data`,
      data,
    });
    return res;
  },
);

export const markAttendanceAcademicCalendar = createAsyncThunk(
  'CRDSlice/markAttendanceAcademicCalendar',
  async (data) => {
    const res = await apiRequest({
      method: 'post',
      url: `/admission-register/mark-attendance`,
      data: data,
    });
    return res;
  },
);

export const getAttendanceTypesForAcademicCalendar = createAsyncThunk(
  'CRDSlice/getAttendanceTypesForAcademicCalendar',
  async (subject_enrollment_id) => {
    const res = await apiRequest({
      method: 'get',
      url: `/admission-register/get-attendance-types-data?subject_enrollment_id=${subject_enrollment_id}`,
    });
    return res;
  },
);

export const deleteCalendarAttendance = createAsyncThunk('asset/deleteCalendarAttendance', async (data) => {
  const res = await apiRequest({
    method: 'delete',
    url: `/admission-register/delete-single-attendance`,
    data: data,
  });
  return res;
});
const CRDSlice = createSlice({
  name: 'CRDSlice',
  initialState,
  reducers: {
    clearStudentProfile: (state, action) => {
      return {
        ...state,
        studentProfile: {},
      };
    },
  },
  extraReducers: (builder) => {
    //..................GETING ALL COURSES................
    builder.addCase(getCoursesForAdmRgstr.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });

    builder.addCase(getCoursesForAdmRgstr.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        courses: action?.payload?.data?.courses,
      };
    });

    //..................GETING ALL PROJECTS................
    builder.addCase(getProjectsForAdmRgstr.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });

    builder.addCase(getProjectsForAdmRgstr.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        projects: action?.payload?.data?.projects,
      };
    });

    //..................GETING ALL ASSIGNED CROS................
    builder.addCase(getAssignedCrosForAdmRgstr.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });

    builder.addCase(getAssignedCrosForAdmRgstr.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        cros: action?.payload?.data?.cros,
      };
    });

    // ------------------GETTING ALL  CRM LISTS----------------------------------------
    builder.addCase(getCRMLists.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getCRMLists.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        crmLists: action.payload?.data,
      };
    });

    // ------------------GETTING ALL CRO UNDER CRM----------------------------------------
    builder.addCase(getCROLists.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getCROLists.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        croList: action.payload?.data,
      };
    });

    // ------------------GETTING ALL CRO DATAS UNDER CRM----------------------------------------
    builder.addCase(getCRMViewCRODatas.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getCRMViewCRODatas.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        croDatas: {
          ...state.croDatas,
          data: action.payload?.data,
          meta: action.payload?.meta,
        },
      };
    });
    // ------------------GETTING ALL LEAD DETAILS FOR SHOWING IN CRO VIEW----------------------------------------
    builder.addCase(getCROViewLeadDetails.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getCROViewLeadDetails.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        leadDetails: {
          ...state.leadDetails,
          data: action.payload?.data || [],
          meta: action.payload?.meta || {},
        },
      };
    });

    // ------------------GETTING ACADEMIC CALENDAR----------------------------------------
    builder.addCase(getAcademicCalendar.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getAcademicCalendar.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        academicCalendar: Array.isArray(action.payload?.data) ? action.payload?.data : [],
      };
    });

    // ------------------GETTING RESCHEDULED ACADEMIC CALENDAR----------------------------------------
    builder.addCase(getRescheduledCalendars.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getRescheduledCalendars.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        rescheduledCalendars: action.payload?.data || [],
      };
    });
    // ------------------GETTING SUBJECT ENROLEMT IDS AGAINST LEAD ID----------------------------------------
    builder.addCase(getSubjectEnrollmentIds.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getSubjectEnrollmentIds.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        subjectEnrollmentIds: action.payload?.data || [],
      };
    });
    // ------------------GETTING LEAD DETAILS----------------------------------------
    builder.addCase(getLeadMinDetails.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getLeadMinDetails.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        leadDetails: action.payload?.data || [],
      };
    });
    // ----------------GET STUDENT PROFILE FOR CRD--------------------------
    builder.addCase(getStudentsProfileForCRD.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getStudentsProfileForCRD.fulfilled, (state, action) => {
      return {
        ...state,
        studentProfile: action.payload?.data,
        loading: false,
      };
    });
    // ----------------GET ADMISSION REGSTR DATA FOR CRD--------------------------
    builder.addCase(getDataForCrdAdmissionRegister.pending, (state, action) => {
      return {
        ...state,
        loading: true,
        admissionRegisterDataGridExtraLoading: true,
      };
    });
    builder.addCase(getDataForCrdAdmissionRegister.fulfilled, (state, action) => {
      return {
        ...state,
        admissionRegisterData: action.payload,
        loading: false,
        admissionRegisterDataGridExtraLoading: false,
      };
    });

    // ----------------GET ADMISSION REGSTR DATA FOR CRD--------------------------
    builder.addCase(getDataForCrdAdmissionRegisterForNewCustomTable.pending, (state, action) => {
      return {
        ...state,
        admissionRegisterNewTableDataLoading: true,
      };
    });
    builder.addCase(getDataForCrdAdmissionRegisterForNewCustomTable.fulfilled, (state, action) => {
      return {
        ...state,
        admissionRegisterNewTableData: action.payload,
        admissionRegisterNewTableDataLoading: false,
      };
    });
    builder.addCase(getDataForCrdAdmissionRegisterForNewCustomTable.rejected, (state, action) => {
      return {
        ...state,
        admissionRegisterNewTableDataLoading: false,
      };
    });

    // ----------------GET COUNTRY AND CODE--------------------------
    builder.addCase(getCountryCodeAndCountry.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getCountryCodeAndCountry.fulfilled, (state, action) => {
      return {
        ...state,
        countryCodeAndCountry: action.payload?.data,
        loading: false,
      };
    });
    // ----------------UPDATE STUDENT PROFILE ADMISSION REGISTER--------------------------
    builder.addCase(updateStudentDataFromAdmRegstr.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(updateStudentDataFromAdmRegstr.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // ------------------------------update CRO NOTES--------------------------
    builder.addCase(updateCroNotes.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateCroNotes.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(updateCroNotes.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
    // ------------------------------GET TRAINER DATA--------------------------
    builder.addCase(getTrainerData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getTrainerData.fulfilled, (state, action) => {
      state.loading = false;
      state.trainerData = action.payload || {};
    });
    // ------------------------------GET TRAINER LISTS--------------------------
    builder.addCase(getTrainerLists.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getTrainerLists.fulfilled, (state, action) => {
      state.loading = false;
      state.trainerLists = action.payload || {};
    });
    // ------------------------------ASSIGNING TRAINER FROM LIST--------------------------
    builder.addCase(assignTutor.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(assignTutor.fulfilled, (state, action) => {
      state.loading = false;
    });
    // ------------------------------GET IN ACTIVE REASONS--------------------------
    builder.addCase(getInactiveReasons.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getInactiveReasons.fulfilled, (state, action) => {
      state.loading = false;
      state.inactiveReasons = action.payload?.data || [];
    });
    // ------------------------------CHANGING TRAINER STATUS--------------------------
    builder.addCase(changeTutorStatus.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(changeTutorStatus.fulfilled, (state, action) => {
      state.loading = false;
    });
    // ------------------------------CHANGING TRAINER STATUS--------------------------
    builder.addCase(editAttendancePerDay.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(editAttendancePerDay.fulfilled, (state, action) => {
      state.loading = false;
    });
    // ------------------------------GET EVALUATION TRACKER DATA--------------------------
    builder.addCase(getEvaluationTracker.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getEvaluationTracker.fulfilled, (state, action) => {
      state.loading = false;
      state.evaluationTracker = action.payload.data || {};
    });
    // ------------------------------POST EVALUATION TRACKER DATA--------------------------
    builder.addCase(postEvaluation.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(postEvaluation.fulfilled, (state, action) => {
      state.loading = false;
    });
    // ------------------------------POST EVALUATION TRACKER DATA--------------------------
    builder.addCase(deleteEvaluationTrack.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteEvaluationTrack.fulfilled, (state, action) => {
      state.loading = false;
    });
    // ------------------------------GET EVALUATION TRACKER DATA--------------------------
    builder.addCase(getAllActiveCourses.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllActiveCourses.fulfilled, (state, action) => {
      state.loading = false;
      state.activeCourses = action.payload.data || {};
    });
    // ------------------------------GET all cro list DATA--------------------------
    builder.addCase(getAllCroLists.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllCroLists.fulfilled, (state, action) => {
      state.loading = false;
      state.croList = action.payload.data || [];
    });
    // -------------------------------getting TOTAL SESSIONS--------------------------
    builder.addCase(getTotalsessions.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getTotalsessions.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        sesssioncount: action.payload.data,
      };
    });
    // --------------------------------updating TOTAL SESSIONS--------------------------
    builder.addCase(updateTotalSessions.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateTotalSessions.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(updateTotalSessions.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
    // -------------------------------updating CERTIFICATE--------------------------
    builder.addCase(updateCertificate.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateCertificate.fulfilled, (state, action) => {
      state.loading = false;
    });
    // -------------------------------------- getting SESSION LOG FOR CRM--------------------------
    builder.addCase(getSessionLogCrm.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getSessionLogCrm.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        sessionLogCrm: action.payload.data,
      };
    });
    // ---------------------------------------------- getting SESSION LOG FOR CRO--------------------------
    builder.addCase(getSessionLogCro.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getSessionLogCro.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        sessionLogCro: action.payload.data,
      };
    });
    // -------------------------------getting TERMINATION DATA--------------------------
    builder.addCase(getTerminationData.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getTerminationData.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        terminationData: action.payload.data,
      };
    });
    // -------------------------------getting TERMINATION REASONS--------------------------
    builder.addCase(getTerminationReasons.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getTerminationReasons.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        terminationReasons: action.payload.data,
      };
    });
    // -------------------------------updating TERMINATION DATA--------------------------
    builder.addCase(updateTerminationData.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(updateTerminationData.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // -------------------------------getting FEE PER SESSION--------------------------
    builder.addCase(getFeePerSession.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getFeePerSession.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        feePerSession: action.payload.data,
      };
    });
    // -------------------------------getting STUDENT ATTENDANCE VIEW--------------------------
    builder.addCase(getStudentAttendanceView.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getStudentAttendanceView.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        studentAttendanceView: action.payload,
      };
    });
    // -------------------------------getting TUTOR ATTENDANCE VIEW--------------------------
    builder.addCase(getTutorAttendanceView.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getTutorAttendanceView.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        tutorAttendanceView: action.payload.data,
      };
    });
    // -------------------------------getting LEDGER DATA--------------------------
    builder.addCase(getLedgerData.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getLedgerData.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        ledgerData: action.payload.data,
      };
    });
    // -------------------------------GET MONTH WISE SEESION DATA AGAINST SUBJECT--------------------------
    builder.addCase(getSessionDetailsAgainstSubEnrolId.pending, (state, action) => {
      return {
        ...state,
        monthWiseDataloading: true,
      };
    });
    builder.addCase(getSessionDetailsAgainstSubEnrolId.fulfilled, (state, action) => {
      return {
        ...state,
        monthWiseDataloading: false,
        monthWiseSessionData: action.payload.data || [],
      };
    });
    // -------------------------------posting CLOSE LEDGER--------------------------
    builder.addCase(CloseLedger.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(CloseLedger.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // ------------------------------ get admn reg data for pqa ----------------------------
    builder.addCase(getAdmissionRegisterDataforPQA.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getAdmissionRegisterDataforPQA.fulfilled, (state, action) => {
      return {
        ...state,
        admissionRegisterDataPQA: action.payload,
        loading: false,
      };
    });
    // ------------------------------ NEW ADMISSIN GLOBAL TABLE PQA ----------------------------
    builder.addCase(getAdmissionRegisterDataforPQANewCustomTable.pending, (state, action) => {
      return {
        ...state,
        admissionRegisterNewTableDataLoading: true,
      };
    });
    builder.addCase(getAdmissionRegisterDataforPQANewCustomTable.fulfilled, (state, action) => {
      return {
        ...state,
        admissionRegisterNewTableData: action.payload,
        admissionRegisterNewTableDataLoading: false,
      };
    });
    builder.addCase(getAdmissionRegisterDataforPQANewCustomTable.rejected, (state, action) => {
      return {
        ...state,
        admissionRegisterNewTableDataLoading: false,
      };
    });
    // -------------------------------- GET CROS UNDER PROJECT ------------------------
    builder.addCase(getCROlistUnderProject.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getCROlistUnderProject.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        crosunderproject: action.payload.data,
      };
    });
    // --------------------------- GET DATA FOR FINANCE -----------------------------------------
    builder.addCase(getAdmissionRegisterDataForFinance.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getAdmissionRegisterDataForFinance.fulfilled, (state, action) => {
      return {
        ...state,
        admissionRegisterDataFinance: action.payload,
        loading: false,
      };
    });

    // --------------------------- GET DATA FOR FINANCE new custom table -----------------------------------------
    builder.addCase(getAdmissionRegisterDataForFinanceNewCustomTable.pending, (state, action) => {
      return {
        ...state,
        admissionRegisterNewTableDataLoading: true,
      };
    });
    builder.addCase(getAdmissionRegisterDataForFinanceNewCustomTable.fulfilled, (state, action) => {
      return {
        ...state,
        admissionRegisterNewTableData: action.payload,
        admissionRegisterNewTableDataLoading: false,
      };
    });
    builder.addCase(getAdmissionRegisterDataForFinanceNewCustomTable.rejected, (state, action) => {
      return {
        ...state,
        admissionRegisterNewTableDataLoading: false,
      };
    });
    // --------------------- GET ALL CROs --------------------------------------------------
    builder.addCase(getAllCroList.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getAllCroList.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        allcrolist: action.payload.data,
      };
    });
    // --------------------------------- UPDATE INCOME FORECAST STATUS ------------------------
    builder.addCase(updateForecast.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(updateForecast.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // --------------------------- GET DATA FOR EXCEL SHEET -----------------------------------------
    builder.addCase(getDataforExcelSheet.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getDataforExcelSheet.fulfilled, (state, action) => {
      return {
        ...state,
        excelSheetData: action.payload.data,
        loading: false,
      };
    });
    // --------------------- GET NON CART STUDENT DATA --------------------------------------------------
    builder.addCase(getNonCartStudentData.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getNonCartStudentData.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        nonCartStudentData: action.payload.data,
      };
    });
    // --------------------- UPDATE NON CART STUDENT DATA --------------------------------------------------
    builder.addCase(updateNonCartStudentData.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(updateNonCartStudentData.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // --------------------- GET UN MAPPED STUDENT --------------------------------------------------
    builder.addCase(getUnMappedStudentUnderCro.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getUnMappedStudentUnderCro.fulfilled, (state, action) => {
      return {
        ...state,
        unMappedStudent: Array.isArray(action.payload.data) ? action.payload.data : [],
        loading: false,
      };
    });
    builder.addCase(getSubjectsUnderEnrollmentId.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getSubjectsUnderEnrollmentId.fulfilled, (state, action) => {
      return {
        ...state,
        subjects: Array.isArray(action.payload.data) ? action.payload.data : [],
        loading: false,
      };
    });
    // --------------------- GET STUDENT LIST AND TUTOR LIST--------------------------------------------------
    builder.addCase(getStudentListAndTutorList.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getStudentListAndTutorList.fulfilled, (state, action) => {
      return {
        ...state,
        studentListAndTutorList: {
          ...state.studentListAndTutorList,
          studentData: action.payload.data?.studentData || [],
          trainerDatas: action.payload.data?.trainerDatas || [],
        },
        loading: false,
      };
    });

    // ---------------------CRO TUTOR UPDATE CHNAGE--------------------------------------------------
    builder.addCase(croTrainerStatusChange.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(croTrainerStatusChange.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    //GET TP HISTORY
    builder.addCase(getTpHistory.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getTpHistory.fulfilled, (state, action) => {
      return {
        ...state,
        tpHistory: Array.isArray(action.payload.data) ? action.payload.data : [],
        loading: false,
      };
    });
    // --------------------------------- Student Perfomance Dashboard ------------------------
    builder.addCase(getStudentPerfomanceDashboard.pending, (state, action) => {
      state.studentPerfomanceDasboard.loading = true;
    });
    builder.addCase(getStudentPerfomanceDashboard.fulfilled, (state, action) => {
      state.studentPerfomanceDasboard.data = action.payload?.data;

      state.studentPerfomanceDasboard.meta = action.payload?.meta;
      state.studentPerfomanceDasboard.loading = false;
    });
    //----------------------- Admission Register studentEdit/profile
    builder.addCase(getAdmRegStudentDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAdmRegStudentDetails.fulfilled, (state, action) => {
      state.loading = false;
      state.admRegStudentProfile = action.payload.data;
    });

    builder.addCase(putAdmRegStudentDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(putAdmRegStudentDetails.fulfilled, (state) => {
      state.loading = false;
    });

    //----------------------- Edit Academic Calender
    builder.addCase(getEditCalender.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getEditCalender.fulfilled, (state, action) => {
      state.loading = false;
      state.academicEdit = action.payload.data;
    });
    builder.addCase(putEditCalender.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(putEditCalender.fulfilled, (state) => {
      state.loading = false;
    });

    //----------------------- get Assessment Details
    builder.addCase(getAssessmentDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAssessmentDetails.fulfilled, (state, action) => {
      state.loading = false;
      state.assessmentDetails.tableData = action.payload?.data ?? [];
      state.assessmentDetails.meta = action.payload?.meta ?? {};
    });

    //----------------------- get Assessment Details Type
    builder.addCase(getAssessmentDetailsType.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAssessmentDetailsType.fulfilled, (state, action) => {
      state.loading = false;
      state.assessmentDetailsTypes = action.payload?.data;
    });
    //----------------------- put Assessment Details
    builder.addCase(putAssessmentDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(putAssessmentDetails.fulfilled, (state, action) => {
      state.loading = false;
    });
    //----------------------- post duplicate Assessment Details
    builder.addCase(postDuplicateAssessmentDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(postDuplicateAssessmentDetails.fulfilled, (state, action) => {
      state.loading = false;
    });
    //----------------------- get TRANSACTION HISTORY
    builder.addCase(getTransactionHistory.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getTransactionHistory.fulfilled, (state, action) => {
      state.loading = false;
      state.transactionHistory = Array.isArray(action.payload?.data) ? action.payload?.data : [];
    });
    //GET ATTENDANCE TYPE
    builder.addCase(getAttendanceTypesForAcademicCalendar.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getAttendanceTypesForAcademicCalendar.fulfilled, (state, action) => {
      return {
        ...state,
        attendanceTypes: Array.isArray(action.payload.data) ? action.payload.data : [],
        loading: false,
      };
    });
    builder.addCase(markAttendanceAcademicCalendar.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(markAttendanceAcademicCalendar.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    builder.addCase(deleteCalendarAttendance.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(deleteCalendarAttendance.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
  },
});

export const { clearStudentProfile } = CRDSlice.actions;
export default CRDSlice.reducer;
